var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiPoweredWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 832,
    viewBox: "0 0 1280 832",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_939_3604)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "#383344"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_939_3604)",
    filter: "url(#filter0_d_939_3604)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.352,
    y: 251.546,
    width: 945.519,
    height: 580.596,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.352,
    y: 210.913,
    width: 945.519,
    height: 621.23,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.352,
    y: 251.546,
    width: 945.519,
    height: 580.596,
    fill: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 198,
    width: 946,
    height: 54,
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.227,
    y: 270.301,
    width: 643.109,
    height: 543.088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.539,
    y: 270.301,
    width: 250.836,
    height: 286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.539,
    y: 575.836,
    width: 250.836,
    height: 286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.102,
    y: 517.229,
    width: 91.4262,
    height: 25.0055,
    rx: 7.81421,
    fill: "#0054AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.852 529.289H361.185V533.77C360.717 533.925 360.233 534.045 359.732 534.131C359.232 534.216 358.67 534.259 358.047 534.259C357.14 534.259 356.371 534.08 355.74 533.722C355.113 533.359 354.637 532.836 354.311 532.153C353.986 531.465 353.823 530.637 353.823 529.668C353.823 528.736 354.004 527.928 354.366 527.244C354.728 526.557 355.256 526.025 355.947 525.651C356.639 525.272 357.478 525.083 358.463 525.083C358.947 525.083 359.415 525.132 359.867 525.23C360.323 525.323 360.74 525.454 361.118 525.62L360.605 526.829C360.304 526.687 359.966 526.567 359.592 526.469C359.218 526.371 358.829 526.323 358.426 526.323C357.787 526.323 357.236 526.461 356.772 526.738C356.312 527.014 355.958 527.405 355.709 527.91C355.461 528.41 355.337 529.003 355.337 529.686C355.337 530.35 355.437 530.932 355.636 531.432C355.835 531.933 356.147 532.324 356.57 532.604C356.997 532.881 357.549 533.02 358.225 533.02C358.562 533.02 358.849 533.001 359.085 532.965C359.321 532.928 359.539 532.887 359.739 532.842V530.541H357.852V529.289ZM365.868 527.25C366.47 527.25 366.987 527.375 367.418 527.623C367.85 527.871 368.182 528.223 368.414 528.679C368.645 529.135 368.761 529.68 368.761 530.315V531.084H364.25C364.266 531.74 364.441 532.244 364.775 532.598C365.113 532.952 365.585 533.129 366.191 533.129C366.623 533.129 367.009 533.089 367.351 533.007C367.697 532.922 368.053 532.798 368.42 532.635V533.801C368.082 533.96 367.738 534.076 367.388 534.149C367.038 534.222 366.619 534.259 366.13 534.259C365.467 534.259 364.883 534.131 364.378 533.874C363.878 533.614 363.485 533.227 363.2 532.714C362.919 532.201 362.779 531.565 362.779 530.803C362.779 530.046 362.907 529.403 363.163 528.874C363.42 528.345 363.78 527.942 364.244 527.666C364.708 527.389 365.249 527.25 365.868 527.25ZM365.868 528.331C365.416 528.331 365.05 528.478 364.769 528.771C364.492 529.064 364.329 529.493 364.281 530.059H367.357C367.353 529.721 367.296 529.422 367.186 529.161C367.081 528.901 366.918 528.697 366.698 528.551C366.482 528.404 366.206 528.331 365.868 528.331ZM373.902 527.25C374.663 527.25 375.255 527.448 375.678 527.843C376.106 528.233 376.319 528.862 376.319 529.729V534.137H374.885V529.998C374.885 529.473 374.777 529.08 374.561 528.819C374.345 528.555 374.012 528.423 373.56 528.423C372.905 528.423 372.449 528.624 372.192 529.027C371.94 529.43 371.814 530.014 371.814 530.779V534.137H370.379V527.379H371.496L371.698 528.294H371.777C371.924 528.058 372.105 527.865 372.321 527.714C372.54 527.56 372.785 527.444 373.053 527.366C373.326 527.289 373.609 527.25 373.902 527.25ZM381.02 527.25C381.622 527.25 382.139 527.375 382.571 527.623C383.002 527.871 383.334 528.223 383.566 528.679C383.798 529.135 383.914 529.68 383.914 530.315V531.084H379.402C379.419 531.74 379.594 532.244 379.927 532.598C380.265 532.952 380.737 533.129 381.344 533.129C381.775 533.129 382.162 533.089 382.504 533.007C382.849 532.922 383.206 532.798 383.572 532.635V533.801C383.234 533.96 382.89 534.076 382.54 534.149C382.19 534.222 381.771 534.259 381.283 534.259C380.619 534.259 380.035 534.131 379.53 533.874C379.03 533.614 378.637 533.227 378.352 532.714C378.071 532.201 377.931 531.565 377.931 530.803C377.931 530.046 378.059 529.403 378.316 528.874C378.572 528.345 378.932 527.942 379.396 527.666C379.86 527.389 380.401 527.25 381.02 527.25ZM381.02 528.331C380.568 528.331 380.202 528.478 379.921 528.771C379.644 529.064 379.482 529.493 379.433 530.059H382.51C382.506 529.721 382.449 529.422 382.339 529.161C382.233 528.901 382.07 528.697 381.85 528.551C381.635 528.404 381.358 528.331 381.02 528.331ZM388.956 527.25C389.07 527.25 389.194 527.257 389.329 527.269C389.463 527.281 389.579 527.297 389.677 527.318L389.542 528.661C389.457 528.636 389.351 528.618 389.225 528.606C389.103 528.594 388.993 528.587 388.895 528.587C388.639 528.587 388.395 528.63 388.163 528.716C387.931 528.797 387.725 528.923 387.546 529.094C387.367 529.261 387.227 529.471 387.125 529.723C387.023 529.975 386.972 530.268 386.972 530.602V534.137H385.532V527.379H386.655L386.85 528.569H386.917C387.052 528.329 387.218 528.109 387.418 527.91C387.617 527.71 387.845 527.552 388.102 527.434C388.362 527.311 388.647 527.25 388.956 527.25ZM393.578 527.25C394.432 527.25 395.077 527.44 395.513 527.818C395.952 528.197 396.172 528.787 396.172 529.589V534.137H395.153L394.878 533.178H394.829C394.638 533.422 394.441 533.624 394.237 533.783C394.034 533.941 393.797 534.059 393.529 534.137C393.264 534.218 392.941 534.259 392.558 534.259C392.155 534.259 391.795 534.186 391.478 534.039C391.16 533.888 390.91 533.661 390.727 533.355C390.544 533.05 390.452 532.663 390.452 532.195C390.452 531.499 390.71 530.976 391.227 530.626C391.748 530.276 392.534 530.083 393.584 530.046L394.756 530.004V529.65C394.756 529.182 394.646 528.848 394.426 528.648C394.211 528.449 393.905 528.349 393.511 528.349C393.173 528.349 392.845 528.398 392.528 528.496C392.21 528.594 391.901 528.714 391.6 528.856L391.136 527.843C391.465 527.668 391.84 527.525 392.259 527.415C392.682 527.305 393.122 527.25 393.578 527.25ZM394.75 530.907L393.877 530.938C393.161 530.962 392.658 531.084 392.369 531.304C392.08 531.524 391.936 531.825 391.936 532.208C391.936 532.541 392.035 532.786 392.235 532.94C392.434 533.091 392.697 533.166 393.022 533.166C393.519 533.166 393.93 533.026 394.255 532.745C394.585 532.46 394.75 532.043 394.75 531.493V530.907ZM400.696 533.099C400.883 533.099 401.068 533.083 401.252 533.05C401.435 533.013 401.602 532.971 401.752 532.922V534.009C401.593 534.078 401.388 534.137 401.136 534.186C400.883 534.234 400.621 534.259 400.348 534.259C399.965 534.259 399.622 534.196 399.316 534.07C399.011 533.939 398.769 533.718 398.59 533.404C398.411 533.091 398.321 532.657 398.321 532.104V528.471H397.399V527.83L398.388 527.324L398.858 525.877H399.762V527.379H401.697V528.471H399.762V532.085C399.762 532.427 399.847 532.682 400.018 532.849C400.189 533.015 400.415 533.099 400.696 533.099ZM405.818 527.25C406.42 527.25 406.937 527.375 407.369 527.623C407.8 527.871 408.132 528.223 408.364 528.679C408.596 529.135 408.712 529.68 408.712 530.315V531.084H404.2C404.216 531.74 404.391 532.244 404.725 532.598C405.063 532.952 405.535 533.129 406.141 533.129C406.573 533.129 406.96 533.089 407.301 533.007C407.647 532.922 408.003 532.798 408.37 532.635V533.801C408.032 533.96 407.688 534.076 407.338 534.149C406.988 534.222 406.569 534.259 406.08 534.259C405.417 534.259 404.833 534.131 404.328 533.874C403.828 533.614 403.435 533.227 403.15 532.714C402.869 532.201 402.729 531.565 402.729 530.803C402.729 530.046 402.857 529.403 403.113 528.874C403.37 528.345 403.73 527.942 404.194 527.666C404.658 527.389 405.199 527.25 405.818 527.25ZM405.818 528.331C405.366 528.331 405 528.478 404.719 528.771C404.442 529.064 404.28 529.493 404.231 530.059H407.308C407.303 529.721 407.246 529.422 407.137 529.161C407.031 528.901 406.868 528.697 406.648 528.551C406.432 528.404 406.156 528.331 405.818 528.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.508,
    y: 338.284,
    width: 506.361,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.414,
    y: 289.836,
    width: 67.9836,
    height: 14.0656,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 594.59,
    width: 95.3334,
    height: 14.0656,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 635.224,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 668.044,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 691.487,
    width: 58.6066,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 714.929,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 738.372,
    width: 62.5137,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 761.814,
    width: 58.6066,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 785.257,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 714.929,
    width: 102.366,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 738.372,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 761.814,
    width: 89.082,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 785.257,
    width: 102.366,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 691.487,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 668.044,
    width: 95.3334,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.719,
    y: 635.224,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 289.836,
    width: 67.9836,
    height: 14.0656,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 318.749,
    width: 175.82,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 336.642,
    width: 203.951,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.383,
    y: 484.41,
    width: 135.967,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.055,
    y: 484.41,
    width: 30.4754,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.164,
    y: 370.322,
    width: 219.579,
    height: 93.7705,
    stroke: "#BBC2D1",
    strokeWidth: 1.56284
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.414,
    y: 789.946,
    width: 67.9836,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.812,
    y: 789.946,
    width: 117.995,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.219,
    y: 789.946,
    width: 94.5519,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.508,
    y: 374.229,
    width: 461.038,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.508,
    y: 410.175,
    width: 527.459,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.508,
    y: 356.257,
    width: 541.525,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.508,
    y: 392.202,
    width: 567.312,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.508,
    y: 428.147,
    width: 506.361,
    height: 9.37705,
    fill: "#BBC2D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 474.195,
    y: 319.53,
    width: 607.945,
    height: 456.35,
    stroke: "#BBC2D1",
    strokeWidth: 1.56284
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.383 653.978H426.525",
    stroke: "#BBC2D1",
    strokeWidth: 0.781421
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-43-inside-1_939_3604",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157 192C157 186.477 161.477 182 167 182H1125C1130.52 182 1135 186.477 1135 192V852C1135 857.523 1130.52 862 1125 862H167C161.477 862 157 857.523 157 852V192Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M157 192C157 186.477 161.477 182 167 182H1125C1130.52 182 1135 186.477 1135 192V852C1135 857.523 1130.52 862 1125 862H167C161.477 862 157 857.523 157 852V192Z",
    stroke: "#221D30",
    strokeWidth: 50,
    mask: "url(#path-43-inside-1_939_3604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.2 607.385C1079.26 589.746 1099.62 554.468 1132.56 554.468C1165.51 554.468 1183.47 589.746 1190.33 607.385",
    stroke: "#221D30",
    strokeWidth: 11.6301
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1069.38,
    cy: 643.439,
    rx: 25.5863,
    ry: 44.776,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_939_3604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1135.16 560C1179.13 560 1214.77 594.448 1214.77 636.941C1214.77 667.048 1196.88 693.114 1170.81 705.754V739.85C1229.49 754.346 1273 807.34 1273 870.499C1273 944.822 1212.75 1005.07 1138.43 1005.07H1123.57C1049.25 1005.07 989 944.822 989 870.499C989 806.278 1033.99 752.566 1094.16 739.151V702.913C1071.02 689.454 1055.54 664.945 1055.54 636.941C1055.54 594.448 1091.19 560 1135.16 560Z",
    fill: "url(#paint0_linear_939_3604)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_939_3604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209 561C214.523 561 219 565.477 219 571V700C219 705.523 214.523 710 209 710H185.809V730.71L236.818 765.512C238.183 766.443 239 767.989 239 769.642V974.6C239 992.494 236.494 1007 218.6 1007H73.4004C55.5064 1007 41 992.494 41 974.6V764.237C41 762.268 42.1568 760.481 43.9541 759.675L109 730.5H109.164V710H90C84.4772 710 80 705.523 80 700V571C80 565.477 84.4772 561 90 561H209Z",
    fill: "url(#paint1_linear_939_3604)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1191.5,
    cy: 643.439,
    rx: 25.5863,
    ry: 44.776,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.56 554.468C1165.5 554.468 1183.47 589.746 1190.33 607.385",
    stroke: "#221D30",
    strokeWidth: 11.6301
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1076.65,
    cy: 643.439,
    rx: 7.26884,
    ry: 14.5377,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1109.21,
    cy: 643.439,
    rx: 7.26884,
    ry: 14.5377,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.27 670C1083.05 676.397 1086.83 680.467 1095.26 680.467C1103.11 680.467 1108.34 675.175 1110.09 670",
    stroke: "#221D30",
    strokeWidth: 5.81507,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 613.001C175.209 613.001 177 614.792 177 617.001V655.894C177 656.866 176.646 657.804 176.005 658.534L161 675.61V751.401L207.773 783.71C208.855 784.457 209.5 785.687 209.5 787.001V845.501C209.5 847.71 207.709 849.501 205.5 849.501C203.291 849.501 201.5 847.71 201.5 845.501V789.098L154.727 756.791C153.645 756.044 153 754.814 153 753.5V674.102C153 673.131 153.354 672.193 153.995 671.463L169 654.385V617.001C169 614.792 170.791 613.001 173 613.001ZM188.5 637.001C190.709 637.001 192.5 638.792 192.5 641.001V669.001C192.5 670.062 192.078 671.079 191.328 671.829L177 686.157V738.853L225.711 771.168C226.828 771.909 227.5 773.16 227.5 774.501V832.501C227.5 834.71 225.709 836.501 223.5 836.501C221.291 836.501 219.5 834.71 219.5 832.501V776.646L170.789 744.333C169.672 743.592 169 742.34 169 741V684.501C169 683.44 169.422 682.423 170.172 681.673L184.5 667.344V641.001C184.5 638.792 186.291 637.001 188.5 637.001ZM192.5 569C194.709 569 196.5 570.791 196.5 573C196.5 575.209 194.709 577 192.5 577H96V636.141L123.395 656.612C124.405 657.367 125 658.555 125 659.816V741C125 742.563 124.089 743.984 122.668 744.635L58.5 774.066V832.001C58.5 834.21 56.7091 836.001 54.5 836.001C52.2909 836.001 50.5 834.21 50.5 832.001V771.501C50.5 769.937 51.411 768.517 52.832 767.865L117 738.433V661.82L89.6055 641.35C88.5951 640.595 88 639.408 88 638.146V573C88 570.791 89.7909 569 92 569H192.5ZM207 569C209.209 569 211 570.791 211 573V588.5C211 590.709 209.209 592.5 207 592.5H113V627.46L141.465 649.734C142.434 650.492 143 651.654 143 652.885V753.5C143 755.045 142.11 756.452 140.714 757.114L75.5 788.031V831.501C75.5 833.71 73.7091 835.501 71.5 835.501C69.2909 835.501 67.5 833.71 67.5 831.501V785.501C67.5 783.956 68.39 782.549 69.7861 781.886L135 750.969V654.832L106.535 632.558C105.566 631.8 105 630.639 105 629.409V588.5C105 586.291 106.791 584.5 109 584.5H203V573C203 570.791 204.791 569 207 569ZM162 772.001C163.657 772.001 165 773.344 165 775.001V821.001C165 822.658 163.657 824.001 162 824.001C160.343 824.001 159 822.658 159 821.001V775.001C159 773.344 160.343 772.001 162 772.001ZM135 772.001C136.343 772.001 137.522 772.893 137.887 774.185L150.887 820.185C151.337 821.78 150.41 823.437 148.815 823.887C147.221 824.338 145.564 823.41 145.113 821.816L140.927 807.001H129.073L124.887 821.816C124.436 823.41 122.779 824.338 121.185 823.887C119.59 823.437 118.663 821.78 119.113 820.185L132.113 774.185L132.19 773.947C132.626 772.785 133.741 772.001 135 772.001ZM130.77 801.001H139.23L135 786.03L130.77 801.001Z",
    fill: "url(#paint2_linear_939_3604)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.269,
    cy: 643.538,
    rx: 7.26884,
    ry: 14.5377,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.831,
    cy: 643.538,
    rx: 7.26884,
    ry: 14.5377,
    fill: "#221D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 673.158L190.133 684.698L202 673.158",
    stroke: "#221D30",
    strokeWidth: 5.82,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_939_3604",
    x: 136,
    y: 176,
    width: 1020.22,
    height: 670.142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_939_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_939_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_939_3604",
    x: 979,
    y: 554,
    width: 304,
    height: 465.072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_939_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_939_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_939_3604",
    x: 31,
    y: 555,
    width: 218,
    height: 466,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_939_3604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_939_3604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_939_3604",
    x1: 1183.28,
    y1: 587.39,
    x2: 904.335,
    y2: 1126.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_939_3604",
    x1: 189.297,
    y1: 588.452,
    x2: -99.9472,
    y2: 1114.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107545"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_939_3604",
    x1: 139,
    y1: 569,
    x2: 139,
    y2: 849.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05AA52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077D3F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_939_3604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 832,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_939_3604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000.22,
    height: 650.142,
    fill: "white",
    transform: "translate(146 182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPoweredWorkflow);
export default __webpack_public_path__ + "static/media/AIPoweredWorkflow.ca6a1c8c58684fed4d0ff2073b420547.svg";
export { ForwardRef as ReactComponent };